import { render, staticRenderFns } from "./index - 副本.vue?vue&type=template&id=542d9987&scoped=true&"
import script from "./index - 副本.vue?vue&type=script&lang=js&"
export * from "./index - 副本.vue?vue&type=script&lang=js&"
import style1 from "./index - 副本.vue?vue&type=style&index=1&id=542d9987&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "542d9987",
  null
  
)

export default component.exports